import React, { useState, useEffect } from "react";
import Select, {createFilter} from "react-select";
import axios from "axios";
import {getAllColumnsForOptionOnViewSettingsApi, getUserViewAllSettingsTerminalApi} from "../Api";
import CustomOption from "../Utils/CustomOption";
import CustomMenuList from "../Utils/CustomMenuList";

function ViewSettingOptions(props) {
  const [recordPerPage, setRecordPerPage] = useState();
  const [columnSortOptions, setColumnSortOptions] = useState([]);
  const [selectedColumnSort, setSelectedColumnSort] = useState();
  const [sortOrderOptions, setSortOrderOptions] = useState();
  const [selectedSortOrder, setSelectedSortOrder] = useState();
  useEffect(() => {
      const fetchAllColumns = async () => {
          const result = await axios.get(`${getAllColumnsForOptionOnViewSettingsApi}`);
          result?.data?.response.map((item, index) =>
              setColumnSortOptions((old) => [
                  ...old,
                  { label: item?.terminalColumnName, value: item?.terminalColumnID },
              ])
          );
      };
      fetchAllColumns();
    setSortOrderOptions([
      { label: "Aesc", value: "aesc" },
      { label: "desc", value: "desc" },
    ]);
    // here call the apis to set options of columns and sortings
    // you can choose put the value in dependency array if the api calling trigger is depends on some value or prop change
  }, []);
  const handleSaveOptionsClick = async () => {
    //   here call the api for the save options
  };
  return (
    <div>
      <form>
        <div class="form-group form-inline">
          <label>Show:</label>
          <input
            class="form-control ml-4"
            value={recordPerPage}
            onChange={(e) => setRecordPerPage(e.target.value)}
          />
          <span className="ml-4">Terminals per page</span>
        </div>
      </form>
      {/*  */}
      <div className="row mt-3">
        <div className="col col-md-4">
          <div className="d-flex justify-content-between align-items-center">
            <label>Sort By Column:</label>
            <div>
              <Select
                  filterOption={createFilter({ ignoreAccents: false })}
                  captureMenuScroll={false}
                  classNamePrefix="custom-select"
                  components={{ Option: CustomOption, MenuList: CustomMenuList }}
                options={columnSortOptions}
                value={selectedColumnSort}
                onChange={(e) => setSelectedColumnSort(e)}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    flex: 1,
                    width: "12.5vw",
                  }),
                }}
              />
            </div>
          </div>
        </div>
        <div className="col col-md-1"></div>
        <div className="col col-md-4">
          <div className="d-flex justify-content-between ">
            <label>Direction:</label>
            <div>
              <Select
                  filterOption={createFilter({ ignoreAccents: false })}
                  captureMenuScroll={false}
                  classNamePrefix="custom-select"
                  components={{ Option: CustomOption, MenuList: CustomMenuList }}
                options={sortOrderOptions}
                value={selectedSortOrder}
                onChange={(e) => setSelectedSortOrder(e)}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    flex: 1,
                    width: "12.5vw",
                  }),
                }}
              />
            </div>
          </div>
        </div>
      </div>
      {/*  */}
      <div className="mt-3 d-flex justify-content-center">
        <span
          class="input-group-text ml-2"
          role="button"
          onClick={() => handleSaveOptionsClick()}
        >
          Set as a Default
        </span>
      </div>
    </div>
  );
}

export default ViewSettingOptions;
